module.exports = __webpack_public_path__ + "img/this-poison-heart.7dc8c9dc.png";